import "../../chunks/server.js";
//#region src/routes/+page.svelte
function _page($$renderer) {
	$$renderer.push(`<div class="flex justify-center items-center h-[calc(100vh-64px)]"><div class="flex"><h1 class="text-3xl text-white">Welcome!</h1></div></div>`);
}
//#endregion
export { _page as default };
